document.addEventListener('alpine:init', () => {
  Alpine.store('resultsData', {
    results: null,
    isSolved: false,
  });
});

document.addEventListener('htmx:afterSwap', (event) => {
  if (event.target.id === 'results') {
    Alpine.store('resultsData', {
      results: JSON.parse(document.getElementById('results-data').textContent),
      isSolved: JSON.parse(document.getElementById('is-solved').textContent),
    });
    // console.log(Alpine.store('resultsData'));
  }
});

document.addEventListener('alpine:init', () => {
  Alpine.data('miakoHandler', () => ({
    loadTypes: JSON.parse(document.getElementById('load-types').textContent),
    variableCategories: JSON.parse(document.getElementById('load-categories').textContent),
    pointLoadDimensions: JSON.parse(document.getElementById('point-load-dimensions').textContent),
    distributedLoadDimensions: JSON.parse(document.getElementById('distributed-load-dimensions').textContent),
    potChoices: JSON.parse(document.getElementById('pot-choices').textContent),
    ovnChoices: JSON.parse(document.getElementById('ovn-choices').textContent),
    potReinforcement: JSON.parse(document.getElementById('pot-reinforcement').textContent),
    heightChoices: JSON.parse(document.getElementById('height-choices').textContent),
    miakoChoices: JSON.parse(document.getElementById('miako-choices').textContent),
    concreteChoices: JSON.parse(document.getElementById('concrete-choices').textContent),
    wwfChoices: JSON.parse(document.getElementById('wwf-choices').textContent),
    topRebarChoices: [8, 10, 12, 14],

    selfWeightUpdateTimeout: null,

    defaults: {
      model: {
        nodes: [],
        members: [],
        dims: [],
        load_cases: {
          G0: {
            index: 0,
            label: 'G0',
            description: 'Vlastní tíha',
            type: 'permanent',
            category: null,
            member_point_loads: [],
            member_distributed_loads: [],
          },
        },
      },
      miakoData: {
        type: '250',
        height: 250,
        miakoHeight: 190,
        concreteHeight: 60,
        concrete: 'c25-30',
        effectiveCreepCoefficient: 2.8,
        concreteCover: 20,
      },
      wwfReinforcement: {
        types: ["6-100"],
        xCoords: [0.0, 4.0],
      },
      topRebars: [],
      spans: {
        left: 0.0,
        middle: [
          {
            len: 4.0,
            pot: "pot-400",
            n: 1.0,
            ovn: "ovn-625",
            bEff: 625.0,
          },
        ],
        right: 0.0,
        totalLen: 4.0,
        maxBEff: 625.0,
      },
    },

    optimize: {
      h: true,
      ovn: true,
      concrete: true,
      wwfChoices: ['5-100', '6-150', '6-100', '8-150', '8-100'],
      rebarChoices: [8, 10, 12],
      maxUsage: 100,
    },

    scene: {
      viewMode: 'loads',
      selectedLoadType: 'load-case',
      selectedCase: '',
      showLoads: true,
      showRebars: true,
      showDimensions: true,
      showNodeLabels: true,
      showMemberLabels: true,
      showReactions: true,
      reactionsScale: 10,
      showAxialForces: true,
      axialForcesScale: 10,
      showShearForces: true,
      shearForcesScale: 10,
      showBendingMoments: true,
      bendingMomentsScale: 10,
      showDisplacements: true,
      displacementsScale: 20,
      feaResults: null,
      designResults: null,
    },

    loadCases: [],
    loadCombinations: [],
    combinationEnvelopes: [],

    uploadStatus: '',
    errors: [],
    fileUploadModalOpen: false,

    updateModel() {
      const newNodes = [];
      const newDims = [];
      const newMembers = [];
      // OH SHOOOT, PROBABLY NOT THE BEST DECISION TO NAME SPAN LENGTH AS LENGTH
      let xCoords = [0.0, +this.spans.left];
      for (let i = 0; i < this.spans.middle.length; i++) {
        xCoords.push(xCoords[xCoords.length - 1] + +this.spans.middle[i].len);
      }
      xCoords.push(xCoords[xCoords.length - 1] + +this.spans.right);

      xCoords = Array.from(new Set(xCoords));

      xCoords.forEach((x, i) => {
        let fixity = {x: 'fixed', z: 'fixed', ry: 'free'};
        if (i === 0 && +this.spans.left > 0) {
          fixity = {x: 'free', z: 'free', ry: 'free'};
        }
        if (i === xCoords.length - 1 && +this.spans.right > 0) {
          fixity = {x: 'free', z: 'free', ry: 'free'};
        }
        newNodes.push(
            {
              label: `N${i + 1}`,
              coords: [+x.toFixed(2), 0, 0],
              fixity: fixity,
            },
        );
      });

      this.spans.totalLen = xCoords[xCoords.length - 1];

      if (this.scene.showDimensions) {
        if (+this.spans.left > 0) {
          newDims.push(
              {
                points: [
                  [xCoords[0], 0, -0.1],
                  [xCoords[1], 0, -0.1],
                  [xCoords[2], 0, -0.1]
                ],
                extrude: -0.45,
              }
          );
        }

        if (+this.spans.right > 0) {
          newDims.push(
              {
                points: [
                  [xCoords[xCoords.length - 3], 0, -0.1],
                  [xCoords[xCoords.length - 2], 0, -0.1],
                  [xCoords[xCoords.length - 1], 0, -0.1]
                ],
                extrude: -0.45,
              }
          );
        }
      }

      this.spans.middle.forEach((span, i) => {
        let rebarLabel = ``;
        let startIdx = i;
        let endIdx = i+1;
        if (+this.spans.left > 0) {
          endIdx += 1;
          if (i !== 0) {
            startIdx += 1;
          }
        }
        if (+this.spans.right > 0 && i === this.spans.middle.length - 1) {
          endIdx += 1;
        }
        const xStart = xCoords[startIdx];
        const xEnd = xCoords[endIdx];

        if (this.scene.showDimensions) {
          if (this.scene.showRebars) {
            const widthCoefficient = Math.round(100 * +this.spans.maxBEff/+span.bEff) / 100;
            rebarLabel += `${widthCoefficient}x(${+span.n}x${span.pot.toUpperCase().replace('-', ' ')}, OVN ${span.ovn.match(/\d+/g).join('/')}, Beff ${span.bEff} mm}`;
            rebarLabel += `\n${widthCoefficient}x(${+span.n * 2}x⌀${this.potReinforcement.find(pot => pot.name === span.pot).d_sides}`;

            if (this.potReinforcement.find(pot => pot.name === span.pot).d_middle) {
              rebarLabel += `+${+span.n}x⌀${this.potReinforcement.find(pot => pot.name === span.pot).d_middle}`;
            }
            rebarLabel += ")";
          }
          newDims.push(
              {
                points: [[xStart, 0, -0.1], [xEnd, 0, -0.1]],
                extrude: -0.7,
                rebarLabel: rebarLabel
              }
          );
        }
      });

      if (this.scene.showDimensions && this.scene.showRebars) {
        this.wwfReinforcement.types.forEach((reinforcement, i) => {
          if (reinforcement !== "null") {
            newDims.push({
              points: [[+this.wwfReinforcement.xCoords[i], 0, 0.1], [+this.wwfReinforcement.xCoords[i+1], 0, 0.1]],
              extrude: 0.8,
              rebarLabel: `KARI ⌀${reinforcement.split('-')[0]}/${reinforcement.split('-')[1]} mm`
            });
          }
        });

        this.topRebars.forEach(rebar  => {
          newDims.push({
            points: [[+rebar.x1 || 0, 0, 0.8], [+rebar.x2 || 0, 0, 0.8]],
            extrude: 0.4,
            rebarLabel: `${rebar.n}x⌀${rebar.diameter}\n`
          });
        });
      }

      for (let i = 0; i < this.spans.middle.length; i++) {
        let startNodeIndex = i + 1;
        let endNodeIndex = i + 2;

        if (+this.spans.left > 0) {
          if (i !== 0) {
            startNodeIndex += 1;
          }
          endNodeIndex += 1;
        }

        if (+this.spans.right > 0 && i === this.spans.middle.length - 1) {
          endNodeIndex += 1;
        }

        newMembers.push(
            {
              label: `E${i + 1}`,
              start_node: `N${startNodeIndex}`,
              end_node: `N${endNodeIndex}`,
              len: +(newNodes[endNodeIndex-1].coords[0] - newNodes[startNodeIndex-1].coords[0]).toFixed(2),
              cross_section: this.spans.middle[i].section,
              hinges: [false, false]
            }
        );
      }

      this.model.nodes = newNodes;
      this.model.dims = newDims;
      this.model.members = newMembers;

      this.viewer.loadModel(this.model);
      if (this.scene.viewMode === 'loads') {
        this.drawLoads();
      } else if (this.scene.viewMode === 'results') {
        let designResults = null;
        if (this.scene.selectedLoadType === 'load-combination') {
          let lc = this.loadCombinations.find(lc => lc.label === this.scene.selectedCase);
          if (lc.description.includes('MSÚ')) {
            designResults = this.scene?.designResults;
          }
        } else if (this.scene.selectedLoadType === 'combination-envelope') {
          if (this.scene.selectedCase.includes('MSÚ')) {
            designResults = this.scene?.designResults;
          }
        }
        if (this.scene.selectedLoadType === 'combination-envelope') {
          this.viewer.drawResults(this.scene.feaResults, this.scene.selectedCase, true, designResults);
        } else {
          this.viewer.drawResults(this.scene.feaResults, this.scene.selectedCase, false, designResults);
        }
      }
      const allBEffs = this.spans.middle.map(span => span.bEff);
      this.spans.maxBEff = Math.max(...allBEffs);
    },

    addSpan() {
      this.spans.middle.push(
          {
            len: 4.0,
            pot: "pot-400",
            n: 1.0,
            ovn: 'ovn-625',
            bEff: 625.0
          }
      );
      this.updateModel();
    },

    updateBEff(span) {
      let ovn;
      switch (span.ovn) {
        case 'ovn-500':
          ovn = 500;
          break;
        case 'ovn-625':
          ovn = 625;
          break;
        default:
          ovn = (500+625) / 2;
      }
      span.bEff = ovn + (span.n - 1) * 160;
    },

    removeSpan(index) {
      const mbrIndex = index + 1;
      // At first, remove the loads that are applied to the span
      for (const lcLabel in this.model.load_cases) {
        const loadCase = this.model.load_cases[lcLabel];
        loadCase.member_point_loads = loadCase.member_point_loads.filter(load => load.target !== `E${mbrIndex}`);
        loadCase.member_distributed_loads = loadCase.member_distributed_loads.filter(load => load.target !== `E${mbrIndex}`);
      }

      // Update targets for the loads that are applied to the spans after the removed one
      for (const lcLabel in this.model.load_cases) {
        const loadCase = this.model.load_cases[lcLabel];

        loadCase.member_distributed_loads.forEach(load => {
          const match = load.target.match(/^E(\d+)$/);
          if (match) {
            const targetIndex = parseInt(match[1], 10);
            if (targetIndex > mbrIndex) {
              load.target = `E${targetIndex - 1}`;
            }
          }
        });

        loadCase.member_point_loads.forEach(load => {
          const match = load.target.match(/^E(\d+)$/);
          if (match) {
            const targetIndex = parseInt(match[1], 10);
            if (targetIndex > mbrIndex) {
              load.target = `E${targetIndex - 1}`;
            }
          }
        });
      }

      this.spans.middle.splice(index, 1);
      this.model.members.splice(index, 1);

      let xCoords = [0.0, +this.spans.left];
      for (let i = 0; i < this.spans.middle.length; i++) {
        xCoords.push(xCoords[xCoords.length - 1] + +this.spans.middle[i].len);
      }
      xCoords.push(xCoords[xCoords.length - 1] + +this.spans.right);

      xCoords = Array.from(new Set(xCoords));

      // Remove WWF which extends beyond the total length
      const totalLen = xCoords[xCoords.length - 1];
      // Reverse iteration for safe removal
      for (let i = this.wwfReinforcement.types.length - 1; i >= 0; i--) {
        if (this.wwfReinforcement.xCoords[i] > totalLen) {
          this.wwfReinforcement.types.splice(i, 1);
          this.wwfReinforcement.xCoords.splice(i, 1);
        }
      }
      // Remove top rebars which have x1 or x2 beyond the total length
      for (let i = this.topRebars.length - 1; i >= 0; i--) {
        if (this.topRebars[i].x1 > totalLen || this.topRebars[i].x2 > totalLen) {
          this.topRebars.splice(i, 1);
        }
      }

      this.updateModel();

    },

    drawLoads() {
      if (this.scene.showLoads && this.scene.viewMode === 'loads') {
        this.viewer.drawLoads( this.model, this.activeLoadCase );
      }
    },

    activeLoadCase: 'G0',

    updateLabels() {
      const newLoadCases = {};
      const loadCasesArray = Object.values(this.model.load_cases);
      const activeLoadCaseIndex = loadCasesArray.findIndex(lc => lc.label === this.activeLoadCase);
      loadCasesArray.forEach((lc, index) => {
        let newLabel;
        switch (lc.type) {
          case 'permanent':
            newLabel = `G${index}`;
            break;
          case 'variable':
            if (lc?.category.includes('snow')) {
              newLabel = `S${index}`;
            } else if (lc?.category.includes('wind')) {
              newLabel = `W${index}`;
            } else {
              newLabel = `Q${index}`;
            }
            break;
          default:
            newLabel = `LC${index+1}`;
        }
        lc.label = newLabel;
        newLoadCases[newLabel] = lc;
      });
      this.model.load_cases = newLoadCases;
      this.activeLoadCase = Object.values(this.model.load_cases)[activeLoadCaseIndex].label;
    },

    setCategory( loadCase ) {
      if (loadCase.type === 'permanent') {
        loadCase.category = null;
      } else {
        loadCase.category = this.variableCategories[0][0];
      }
    },

    addLoadCase() {
      const idx = Object.keys(this.model.load_cases).length;
      const newLabel = `G${idx}`;
      this.model.load_cases[newLabel] = {
        index: idx,
        label: newLabel,
        description: '',
        type: 'permanent',
        category: null,
        member_point_loads: [],
        member_distributed_loads: [],
      };
      this.activeLoadCase = newLabel;
      this.updateLabels();
      this.deleteResults();
    },

    removeLoadCase( label ) {
      if (Object.keys(this.model.load_cases).length > 1) {
        if (label === 'G0') {
          alert('Nelze odstranit vlastní tíhu!');
          return;
        }
        if (this.activeLoadCase === label) {
          this.activeLoadCase = Object.values(this.model.load_cases)[0].label;
        }
        delete this.model.load_cases[label];
        this.updateLabels();
        this.deleteResults();
      } else {
        alert('Musí existovat alespoň jeden zatěžovací stav!');
      }
    },

    addPointLoad(lcLabel) {
      this.model.load_cases[lcLabel].member_point_loads.push({
        target: this.model.members[0].label,
        lcs: true,
        x_local: 0,
        components: [0, 0, -10, 0, 0, 0],
        dimension: 'line',
      });
      this.deleteResults();
    },

    removePointLoad(lcLabel, index) {
      this.model.load_cases[lcLabel].member_point_loads.splice(index, 1);
      this.deleteResults();
    },

    addDistributedLoad(lcLabel) {
      this.model.load_cases[lcLabel].member_distributed_loads.push({
        target: this.model.members[0].label,
        lcs: false,
        projection: false,
        x_local: [0, this.model.members[0].len],
        components: this.getDistributedLoadComponents(lcLabel),
        dimension: 'area',
      });
      this.deleteResults();
    },

    getDistributedLoadComponents(lcLabel) {
      const loadCase = this.model.load_cases[lcLabel];

      // console.log('loadCase', loadCase);
      // console.log(this.loadCases);

      switch (loadCase.type) {
        case 'permanent':
          return [0, 0, -2, 0, 0, -2];
        case 'variable':
          switch (loadCase.category) {
            case 'a':
              return [0, 0, -1.5, 0, 0, -1.5];
            case 'b':
              return [0, 0, -2.5, 0, 0, -2.5];
            case 'c':
              return [0, 0, -3.0, 0, 0, -3.0];
            case 'd':
              return [0, 0, -5.0, 0, 0, -5.0];
            case 'e':
              return [0, 0, -7.5, 0, 0, -7.5];
            case 'f':
              return [0, 0, -2.5, 0, 0, -2.5];
            case 'g':
              return [0, 0, -5.0, 0, 0, -5.0];
            case 'h':
              return [0, 0, -0.75, 0, 0, -0.75];
            case 'snow < 1000 m':
              return [0, 0, -1.2, 0, 0, -1.2];
            case 'snow > 1000 m':
              return [0, 0, -2.4, 0, 0, -2.4];
            default:
              return [0, 0, -2.0, 0, 0, -2.0];
          }
        default:
          return [0, 0, -2.0, 0, 0, -2.0];
      }
    },

    removeDistributedLoad(lcLabel, index) {
      this.model.load_cases[lcLabel].member_distributed_loads.splice(index, 1);
      this.deleteResults();
    },

    setActiveLoadCase( lcLabel ) {
      this.activeLoadCase = lcLabel;
    },

    changeCeilingType( ) {
      switch (this.miakoData.type) {
        case '210':
          this.miakoData.height = 210;
          this.miakoData.miakoHeight = 150;
          this.miakoData.concreteHeight = 60;
          break;
        case '250':
          this.miakoData.height = 250;
          this.miakoData.miakoHeight = 190;
          this.miakoData.concreteHeight = 60;
          break;
        case '250bn':
          this.miakoData.height = 250;
          this.miakoData.miakoHeight = 250;
          this.miakoData.concreteHeight = 0;
          break;
        case '290':
          this.miakoData.height = 290;
          this.miakoData.miakoHeight = 230;
          this.miakoData.concreteHeight = 60;
      }
    },

    addWWFReinforcement() {
      if (this.wwfReinforcement.length === 0) {
        this.wwfReinforcement.push(
            {
              types: ["6-100"],
              x: [0.0, this.spans.totalLen],
            }
        );
        return;
      }

      const newX = (Math.random() * +this.spans.totalLen).toFixed(1);

      this.wwfReinforcement.xCoords.push(+newX);
      this.wwfReinforcement.types.push('6-100');
      this.wwfReinforcement.xCoords.sort((a, b) => +a - +b);
    },

    removeWWFReinforcement(index) {
      this.wwfReinforcement.types.splice(index, 1);
      this.wwfReinforcement.xCoords.splice(index, 1);
    },

    addTopRebar() {
      this.topRebars.push(
          {
            n: 1,
            diameter: 10,
            x1: null,
            x2: null,
          }
      );
    },

    removeTopRebar(index) {
      this.topRebars.splice(index, 1);
    },

    updateSelfWeight() {
      const csrfMeta = document.querySelector("meta[name='csrf-token']");
      if (!csrfMeta) {
        console.error("CSRF token meta tag not found.");
        return;
      }
      const csrfToken = csrfMeta.content;
      fetch('/miako/get-self-weight/', {
        method: 'POST',
        headers: {
          "X-CSRFToken": csrfToken,
          'Content-Type': 'application/json; charset=utf-8',
        },
        credentials: 'same-origin',
        body: JSON.stringify({
          spans: this.spans,
          miakoData: this.miakoData,
          model: this.model
        }),
      })
          .then(res => res.json())
          .then(data => {
            this.model.load_cases.G0.member_distributed_loads = data.self_weight;
            this.updateModel();
          })
          .catch(error => console.error('Error:', error));
    },

    delayUpdateSelfWeight() {
      // Clear the timeout if it has already been set
      clearTimeout(this.selfWeightUpdateTimeout);
      // Set a new timeout to call the update function after 0.8 second
      this.selfWeightUpdateTimeout = setTimeout(() => {
        this.updateSelfWeight();
      }, 500);
    },

    getMaxUsage( memberValues ) {
      if (this.scene.selectedLoadType === 'load-combination' || this.scene.selectedLoadType === 'combination-envelope') {
        const usage = memberValues[this.scene.selectedCase]?.max_usage || 0;
        return (usage * 100).toFixed(2);
      } else {
        return 'N/A';
      }
    },

    deleteResults() {
      this.$store.resultsData.isSolved = false;
      this.$store.resultsData.results = null;
      this.scene.feaResults = null;
      this.scene.designResults = null;
      this.viewer.clearResults();
      this.scene.viewMode = 'loads';
    },

    getModelData() {
      return {
        miakoData: this.miakoData,
        wwfReinforcement: this.wwfReinforcement,
        topRebars: this.topRebars,
        spans: this.spans,
        model: this.model,
        version: document.getElementById('app-version').dataset.version,
        date: new Date().toISOString(),
      };
    },

    resetModel() {
      this.deleteResults();
      this.applyModel(this.defaults);
      this.delayUpdateSelfWeight();
      this.activeLoadCase = 'G0';
    },

    downloadModel() {
      // Helper function to format the date
      const formatDate = (dateStr) => {
        const date = new Date(Date.parse(dateStr));
        // console.log(date, typeof(date));
        const pad = (n) => n.toString().padStart(2, '0');
        const year = date.getFullYear();
        const month = pad(date.getMonth() + 1); // Months are zero-based
        const day = pad(date.getDate());
        const hours = pad(date.getHours());
        const minutes = pad(date.getMinutes());
        const seconds = pad(date.getSeconds());
        return `${year}-${month}-${day}-${hours}-${minutes}-${seconds}`;
      };

      const data = this.getModelData();
      const dataStr = JSON.stringify(data, null, 2);
      // const dataStr = JSON.stringify(data);
      const blob = new Blob([dataStr], { type: 'application/json' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `miako_${formatDate(data.date)}.json`;

      // Append to the body to make it work in Firefox
      document.body.appendChild(a);
      a.click();

      // Clean up
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    },

    uploadModel(event) {
      // console.log(event);
      const file = event.target.files[0];
      if (!file) {
        this.uploadStatus = 'Nebyl vybrán žádný soubor.';
        return;
      }

      const reader = new FileReader();

      reader.onload = (e) => {
        try {
          const content = e.target.result;
          const importedData = JSON.parse(content);
          // Validate the imported model structure
          const result = this.validateImportedModel(importedData);
          this.errors = result.errors;
          if (result.isValid) {
            this.uploadStatus = 'Soubor byl úspěšně načten.';
            this.deleteResults();
            this.applyModel(importedData);
            this.activeLoadCase = 'G0';
          } else {
            this.uploadStatus = "Neplatná struktura souboru.";
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
          this.uploadStatus = 'Chyba při čtení souboru.';
        } finally {
          this.$refs.uploadInput.value = null;
        }
      };
      reader.onerror = () => {
        // console.log('File reading failed.');
        this.uploadStatus('Soubor se nepodařilo načíst.');
        this.$refs.uploadInput.value = null;
      };
      reader.readAsText(file);

      this.fileUploadModalOpen = true;
    },

    validateImportedModel(model) {
      const errors = [];

      // Helper functions
      const isNonEmptyString = (value) => typeof value === 'string' && value.trim() !== '';
      const isNumber = (value) => typeof +value === 'number' && !isNaN(+value);

      // 1. Root object validation
      if (!model || typeof model !== 'object') {
        errors.push('Soubor musí obsahovat nenulový objekt.');
        return {isValid: false, errors};
      }

      const requiredRootProps = ['miakoData', 'wwfReinforcement', 'spans', 'model', 'version', 'date'];
      requiredRootProps.forEach(prop => {
        if (!(prop in model)) {
          errors.push(`Chybějící vlastnost na nejvyšší úrovni: ${prop}.`);
        }
      });

      // Proceed only if all top-level properties are present
      if (errors.length > 0) {
        return {isValid: false, errors};
      }

      // 2. miakoData validation
      const miakoData = model.miakoData;
      const requiredMiakoProps = [
        {
          prop: 'type',
          type: 'string',
          choices: this.heightChoices.map(item => item[0]),
        },
        {
          prop: 'height',
          type: 'number',
          min: 200,
        },
        {
          prop: 'miakoHeight',
          type: 'number',
          choices: this.miakoChoices.map(item => item[0]),
        },
        {
          prop: 'concreteHeight',
          type: 'number',
          min: 0,
        },
        {
          prop: 'effectiveCreepCoefficient',
          type: 'number',
          min: 0,
        },
        {
          prop: 'concreteCover',
          type: 'number',
          min: 0,
        }
      ];
      if (typeof miakoData !== 'object' || miakoData === null) {
        errors.push('miakoData musí být nenulový objekt.');
      } else {
        requiredMiakoProps.forEach(item => {
          if (!(item.prop in miakoData)) {
            errors.push(`miakoData chybí vlastnost: ${item.prop}`);
            return;
          }

          const value = miakoData[item.prop];

          // Type control
          if (item.type === 'string' && !isNonEmptyString(value)) {
            errors.push(`miakoData.${item.prop} musí být řetězec.`);
            return;
          }
          if (item.type === 'number' && !isNumber(value)) {
            errors.push(`miakoData.${item.prop} musí být číslo.`);
            return;
          }

          // Choices control
          if (item.choices && Array.isArray(item.choices)) {
            if (!item.choices.includes(`${value}`)) {
              const choiceStr = item.choices.join(', ');
              errors.push(`miakoData.${item.prop} musí být jedna z následujících hodnot: ${choiceStr}.`);
              // console.log(item.choices, value);
              return;
            }
          }

          // Interval control
          if (item.type === 'number') {
            if ('min' in item && value < item.min) {
              errors.push(`miakoData.${item.prop} musí být větší nebo rovno ${item.min}.`);
            }
            if ('max' in item && value > item.max) {
              errors.push(`miakodata.${item.prop} musí být menší nebo rovno ${item.max}`);
            }
          }
        });
      }

      // 3. wwfReinforcement validation
      const wwfReinforcement = model.wwfReinforcement;
      const requiredWwfReinforcementProps = [
        {
          prop: 'types',
          type: 'array',
          elementType: 'str',
          elementChoices: this.wwfChoices.map(item => item[0])
        },
        {
          prop: 'xCoords',
          type: 'array',
          elementType: 'number'
        }
      ];

      if (typeof wwfReinforcement !== 'object' || wwfReinforcement === null) {
        errors.push('wwfReinforcement musí být neprázdný objekt.');
      } else {
        if (wwfReinforcement.types.length !== wwfReinforcement.xCoords.length - 1) {
          if (miakoData.type !== '250bn') {
            errors.push('Pole wwf.xCoords musí obsahovat o jeden element méně než pole wwf.length.');
          }
        }

        requiredWwfReinforcementProps.forEach(item => {
          if (!(item.prop in wwfReinforcement)) {
            errors.push(`wwfReinforcement chybí vlastnost: ${item.prop}`);
            return;
          }

          if (miakoData.type === '250bn') {
            // If type is '250bn'; no need for wwf.
            return;
          }

          const value = wwfReinforcement[item.prop];

          if (item.type === 'array') {
            if (!Array.isArray(value)) {
              errors.push(`wwfReinforcement.${item.prop} musí být pole.`);
              return;
            }
            value.forEach((element, index) => {
              if (item.elementType === 'string' && !isNonEmptyString(element)) {
                errors.push(`wwfReinforcement.${item.prop}[${index}] musí být neprázdný řetězec.`);
              }
              if (item.elementType === 'number' && !isNumber(element)) {
                errors.push(`wwfReinforcement.${item.prop}[${index}] musí být číslo.`);
              }

              if (item.elementChoices) {
                if (!Array.isArray(item.elementChoices)) {
                  if (!item.elementChoices.includes(element)) {
                    const choiceStr = item.choices.join(', ');
                    errors.push(`wwfReinforcement.${item.prop}[${index}] musí být jedna z následujících hodnot: ${choiceStr}.`);
                    return;
                  }
                }
              }
            });
          }
        });
      }

      // 4. topRebars validation
      const topRebars = model.topRebars;
      if (!Array.isArray(topRebars)) {
        errors.push('topRebars by měl být pole.');
      } else {
        topRebars.forEach((rebar, index) => {
          if (typeof rebar !== "object" || rebar === null) {
            errors.push(`topRebars[${index}] by měl být objekt.`);
            return;
          }

          const requiredRebarProps = ['n', 'diameter', 'x1', 'x2'];
          requiredRebarProps.forEach(prop => {
            if (!(prop in rebar)) {
              errors.push(`topRebars[${index}] chybí vlastnost: ${prop}.`);
            }
            if (!isNumber(rebar[prop])) {
              errors.push(`topRebars[${index}].${prop} by měl být číslo.`);
            }
          });
        });
      }

      // 5. spans validation
      const spans = model.spans;
      if (typeof spans !== 'object' || spans === null) {
        errors.push('spans by měl být neprázdný objekt.');
      } else {
        const requiredSpansProps = ['left', 'middle', 'right', 'totalLen'];
        requiredSpansProps.forEach(prop => {
          if (!(prop in spans)) {
            errors.push(`spans chybí vlastnost: ${prop}.`);
          }
        });

        if ('left' in spans && !isNumber(spans.left)) {
          errors.push('spans.left by měl být číslo.');
        }
        if ('right' in spans && !isNumber(spans.right)) {
          errors.push('spans.right by měl být číslo.');
        }
        if ('totalLen' in spans && !isNumber(spans.totalLen)) {
          errors.push('spans.totalLen by měl být číslo.');
        }

        if ('middle' in spans) {
          if (!Array.isArray(spans.middle)) {
            errors.push('spans.middle by měl být pole.');
          } else {
            spans.middle.forEach((span, index) => {
              if (typeof span !== 'object' || span === null) {
                errors.push(`spans.middle[${index}] by měl být objekt.`);
                return;
              }

              const requiredSpanProps = ['len', 'pot', 'n', 'ovn', 'bEff'];
              requiredSpanProps.forEach(prop => {
                if (!(prop in span)) {
                  errors.push(`spans.middle[${index}] chybí vlastnost: ${prop}.`);
                }
              });

              if ('len' in span && !isNumber(span.len)) {
                errors.push(`spans.middle[${index}].len by měl být číslo.`);
              }
              if (!(span.len > 0)) {
                errors.push(`spans.middle[${index}].len musí být větší než 0.`);
              }
              if ('pot' in span && !isNonEmptyString(span.pot)) {
                errors.push(`spans.middle[${index}].pot by měl být neprázdný řetězec.`);
              }
              const potChoices = this.potChoices.map(item => item[0]);
              if (!(potChoices.includes(span.pot))) {
                const choicesStr = potChoices.join(', ');
                errors.push(`spans.middle[${index}].pot musí být jedna z následujících hodnot: ${choicesStr}.`);
                // console.log(potChoices, span.pot);
              }
              if ('n' in span && !isNumber(span.n)) {
                errors.push(`spans.middle[${index}].n by měl být číslo.`);
              }
              if (!(span.n > 0)) {
                errors.push(`spans.middle[${index}].n musí být větší než 0.`);
              }
              if ('ovn' in span && !isNonEmptyString(span.ovn)) {
                errors.push(`spans.middle[${index}].ovn by měl být neprázdný řetězec.`);
              }
              const ovnChoices = this.ovnChoices.map(item => item[0]);
              if (!(ovnChoices.includes(span.ovn))) {
                const choicesStr = ovnChoices.join(', ');
                errors.push(`spans.middle[${index}].ovn musí být jedna z následujících hodnot: ${choicesStr}.`);
                // console.log(ovnChoices, span.ovn);
              }
              if ('bEff' in span && !isNumber(span.bEff)) {
                errors.push(`spans.middle[${index}].bEff by měl být číslo.`);
              }
            });
          }
        }
      }
      return { isValid: errors.length === 0, errors };
    },

    applyModel(data) {
      this.miakoData = JSON.parse(JSON.stringify(data.miakoData));
      this.wwfReinforcement = JSON.parse(JSON.stringify(data.wwfReinforcement));
      this.topRebars = JSON.parse(JSON.stringify(data.topRebars));
      this.spans = JSON.parse(JSON.stringify(data.spans));
      this.model = JSON.parse(JSON.stringify(data.model));
    },

    init() {
      this.applyModel(this.defaults);

      this.$watch('$store.resultsData', newVal => {
        if (newVal) {
          this.loading = false;
        }
        if (newVal && newVal.results) {
          this.loadCases = newVal.results.load_cases || [];
          this.loadCombinations = newVal.results.load_combinations || [];
          this.combinationEnvelopes = newVal.results.combination_envelopes || [];

          // console.log(this.loadCases);
          // console.log(this.loadCombinations);
          // console.log(this.combinationEnvelopes);

          this.scene.feaResults = newVal.results.fea_results || null;
          this.scene.designResults = newVal.results.design_results || null;

          if (newVal.isSolved) {
            setTimeout(() => {
              if (newVal.results.optimization) {
                this.miakoData = newVal.results.optimization.miakoData;
                this.spans = newVal.results.optimization.spans;
                this.wwfReinforcement = newVal.results.optimization.wwfReinforcement || [];
                this.topRebars = newVal.results.optimization.topRebars || [];
              }
              this.viewer.loadModel(this.model);
              this.scene.viewMode = 'results';
              this.scene.selectedLoadType = 'combination-envelope';
              this.scene.selectedCase = "MSÚ";
            }, 200);
          }
        }
      });
      const canvas = document.getElementById('section-scene');
      this.viewer = new window.WBApp.utils.Viewer(canvas);
      this.viewer.config.updateSettings({
        showGrid: false,
        showOrigin: false,
        showNodeLabels: true,
        showMemberLabels: true,
        supportsScale: 0.7,
      });

      this.$watch('spans.totalLen', () => {
        this.wwfReinforcement.xCoords[this.wwfReinforcement.xCoords.length - 1] = this.spans.totalLen;
        this.updateModel();
      });

      setTimeout(() => {
        this.updateModel();
        this.updateSelfWeight();
        this.viewer.loadModel(this.model);
        setTimeout(() => {
          this.drawLoads();
        }, 50);
      }, 1000);

      this.$watch('miakoData.type', (newVal, oldVal) => {
        if (newVal === '250bn') {
          this.wwfReinforcement = {
            types: [],
            xCoords: [],
          };
        }
        if (oldVal === '250bn' && newVal !== '250bn') {
          this.wwfReinforcement = {
            types: ["6-100"],
            xCoords: [0.0, this.spans.totalLen],
          };
        }
        this.updateModel();
      });

      this.$watch('scene.showNodeLabels', (newVal) => {
        this.viewer.config.updateSetting('showNodeLabels', newVal);
      });

      this.$watch('scene.showMemberLabels', (newVal) => {
        this.viewer.config.updateSetting('showMemberLabels', newVal);
      });

      this.$watch('scene.showDimensions', () => {
        this.updateModel();
      });

      this.$watch('scene.showRebars', () => {
        this.updateModel();
      });

      this.$watch('scene.selectedLoadType', () => {
        switch (this.scene.selectedLoadType) {
          case 'load-case':
            this.scene.selectedCase = this.loadCases[0].label;
            break;
          case 'load-combination':
            this.scene.selectedCase = this.loadCombinations[0].label;
            break;
          case 'combination-envelope':
            this.scene.selectedCase = this.combinationEnvelopes[0].label;
            break;
        }
      });

      this.$watch('scene.selectedCase', (newVal) => {
        if (this.scene.viewMode === 'results') {
          let designResults = null;
          if (this.scene.selectedLoadType === 'load-combination') {
            let lc = this.loadCombinations.find(lc => lc.label === newVal);
            if (lc.description.includes('MSÚ')) {
              designResults = this.scene?.designResults;
            }
          } else if (this.scene.selectedLoadType === 'combination-envelope') {
            if (newVal.includes('MSÚ')) {
              designResults = this.scene?.designResults;
            }
          }

          if (this.scene.selectedLoadType === 'combination-envelope') {
            this.viewer.drawResults(this.scene.feaResults, newVal, true, designResults);
          } else {
            this.viewer.drawResults(this.scene.feaResults, newVal, false, designResults);
          }
        }
      });

      this.$watch('scene.viewMode', (newVal) => {
        if (newVal === 'loads') {
          this.viewer.clearResults();
          this.drawLoads();
        }  else {
          this.viewer.clearLoads();
          const isEnvelope = this.scene.selectedLoadType === 'combination-envelope';
          let designResults = null;
          if (this.scene.selectedLoadType === 'load-combination') {
            let lc = this.loadCombinations.find(lc => lc.label === this.scene.selectedCase);
            if (lc.description.includes('MSÚ')) {
              designResults = this.scene?.designResults;
            }
          } else if (this.scene.selectedLoadType === 'combination-envelope') {
            if (this.scene.selectedCase.includes('MSÚ')) {
              designResults = this.scene?.designResults;
            }
          }
          this.viewer.drawResults(this.scene.feaResults, this.scene.selectedCase, isEnvelope, designResults);
        }
      });

      this.$watch('scene.showReactions', (newVal) => {
        this.viewer.config.updateSetting('showReactions', newVal);
      });

      this.$watch('scene.showAxialForces', (newVal) => {
        this.viewer.config.updateSetting('showAxialForces', newVal);
      });

      this.$watch('scene.showShearForces', (newVal) => {
        this.viewer.config.updateSetting('showShearForces', newVal);
      });

      this.$watch('scene.showBendingMoments', (newVal) => {
        this.viewer.config.updateSetting('showBendingMoments', newVal);
      });

      this.$watch('scene.showDisplacements', (newVal) => {
        this.viewer.config.updateSetting('showDeformations', newVal);
      });

      this.$watch('scene.reactionsScale', (newVal) => {
        this.viewer.config.updateSetting('reactionsScaleFactor', newVal / 10);
      });

      this.$watch('scene.axialForcesScale', (newVal) => {
        this.viewer.config.updateSetting('axialForcesScaleFactor', newVal / 10);
      });

      this.$watch('scene.shearForcesScale', (newVal) => {
        this.viewer.config.updateSetting('shearForcesScaleFactor', newVal / 10);
      });

      this.$watch('scene.bendingMomentsScale', (newVal) => {
        this.viewer.config.updateSetting('bendingMomentsScaleFactor', newVal / 10);
      });

      this.$watch('scene.displacementsScale', (newVal) => {
        this.viewer.config.updateSetting('deformationsScaleFactor', newVal );
      });

      this.$watch('scene.showLoads', (newVal) => {
        if (newVal) {
          this.drawLoads();
        } else {
          this.viewer.clearLoads();
        }
      });

      this.$watch('activeLoadCase', () => {
        if (this.scene.viewMode === 'loads') {
          this.drawLoads();
        }
      });
    }
  }));
});